var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22V22H0z",
    transform: "translate(-917 -19) translate(917.575 19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M3.931 16.524h14.9c.512 0 .93-.432.93-.96 0-.529-.418-.96-.93-.96H3.93c-.512 0-.931.431-.931.96 0 .528.419.96.931.96zm0-4.802h14.9c.512 0 .93-.432.93-.96s-.418-.96-.93-.96H3.93c-.512 0-.931.432-.931.96s.419.96.931.96zM3 5.96c0 .528.419.96.931.96h14.9c.512 0 .93-.432.93-.96s-.418-.96-.93-.96H3.93C3.42 5 3 5.432 3 5.96z",
    transform: "translate(-917 -19) translate(917.575 19)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.32aeeb8270cdf4239d7a32bb59da059b.svg";
export { ForwardRef as ReactComponent };